import { create } from 'zustand'

const useWordPressStore = create((set) => ({
  // Connected WordPress sites
  connectedSites: [],

  // Current connection state
  currentConnection: null,
  isConnecting: false,
  connectionError: null,

  // WordPress scan results (stored in memory, not localStorage)
  wpScanResults: null,

  // Actions
  addConnectedSite: (site) =>
    set((state) => ({
      connectedSites: [...state.connectedSites, site],
    })),
  removeConnectedSite: (siteUrl) =>
    set((state) => ({
      connectedSites: state.connectedSites.filter((site) => site.url !== siteUrl),
    })),
  setCurrentConnection: (connection) => set({ currentConnection: connection, connectionError: null }),
  setIsConnecting: (isConnecting) => set({ isConnecting }),
  setConnectionError: (error) => set({ connectionError: error }),
  clearConnection: () => set({ currentConnection: null, connectionError: null }),
  setWpScanResults: (results) => set({ wpScanResults: results }),
  clearWpScanResults: () => set({ wpScanResults: null }),
}))

export default useWordPressStore
